/* eslint-env browser */
import * as React from 'react'

import withTranslator from '../../../client/clientjs/components/TranslatorProvider'

const PropTypes = require('prop-types')

const Table = require('../../../client/clientjs/components/Table')

class RankingTable extends React.Component {
  constructor(props) {
    super(props)

    const { translate, rounds, ranking, fishCatchesByRoundId } = props

    const rows = rounds.map(round => ({
      ...(ranking.scoresByRound || {})[round.id],
      fishCatches: (fishCatchesByRoundId[round.id] || []).sort((a, b) => b.contestAsso.score - a.contestAsso.score),
      round,
    }))

    const columns = [
      {
        name: 'roundName',
        display: translate('ranking.round'),
        getCellValue: row => (row.round.isSecret ? '[SECRET ROUND]' : row.round.name),
        isSortable: true,
      },
      {
        name: 'points',
        display: translate('ranking.roundPoints'),
        getCellValue: row => row.points,
        getCellSubRowValue: (row, subRow) => {
          const fc = subRow
          return (
            <article className="media">
              <figure className="media-left">
                <p className="image is-64x64">
                  <a href={`/users/${fc.createdBy}/catches/${fc.id}`} target="_blank">
                    {fc.medias && fc.medias.length > 0 && (
                      <img
                        src={fc.medias[0].url_100}
                        height="50"
                        alt="fish catch"
                        className="has-object-fit-contain"
                        style={{ maxHeight: '100%' }}
                      />
                    )}
                  </a>
                </p>
              </figure>
              <div className="media-content">
                <div className="content">
                  {fc.speciesCustomName ||
                    (fc.fish && fc.fish.names && fc.fish.names.length ? fc.fish.names[0].value : '')}
                  <br />
                  {fc.size ? `${fc.size}cm` : ''}
                </div>
              </div>
            </article>
          )
        },
        isSortable: true,
        isTextCentered: true,
        isBold: true,
      },
      {
        name: 'score',
        display: translate('ranking.score'),
        getCellValue: row => row.score,
        getCellSubRowValue: (row, subRow, subRowIdx) => {
          const { keepOnlyTop } = row.round.settings || {}
          const fc = subRow
          return !keepOnlyTop || subRowIdx < keepOnlyTop ? fc.contestAsso.score : `(${fc.contestAsso.score})`
        },
        isSortable: true,
        isTextCentered: true,
      },
    ]

    this.state = {
      rows,
      columns,
    }

    this.onRowClick = this.onRowClick.bind(this)
  }

  onRowClick(row) {
    const { rows } = this.state

    const rowRankingIndex = rows.findIndex(elt => elt.round.id === row.round.id)

    if (rowRankingIndex === -1) {
      return
    }

    const rowRanking = rows[rowRankingIndex]

    rows[rowRankingIndex] = {
      ...rowRanking,
      isDisplayed: !rowRanking.isDisplayed,
    }

    this.setState({
      rows,
    })
  }

  render() {
    const { rows, columns } = this.state

    return (
      <Table
        rows={rows}
        columns={columns}
        getRowKey={row => row.round.id}
        onRowClick={this.onRowClick}
        getSubRows={row => (row.isDisplayed ? row.fishCatches || [] : [])}
        getSubRowKey={(row, subRow) => `${row.round.id}-subrow-${subRow.id}`}
        defaultSortBy="points"
        defaultSortASC={false}
        isFullWidth
        tableClass="is-size-7 is-size-8-mobile"
      />
    )
  }
}

RankingTable.propTypes = {
  translate: PropTypes.func.isRequired,
  ranking: PropTypes.object,
  fishCatchesByRoundId: PropTypes.object,
  rounds: PropTypes.array.isRequired,
}

RankingTable.defaultProps = {
  ranking: {},
  fishCatchesByRoundId: {},
}

module.exports = withTranslator(RankingTable)
